import { NavLink } from 'react-router-dom';
import { Logo } from '@/components/foundations';
import { HelpBox } from './HelpBox';
import { APP_NAV, type NavGroupConfig } from './nav';
import { NavGroup } from './NavGroup';
import { DEFAULT_STORE, StoreSwitcher, type StoreInfo } from './StoreSwitcher';

export type { StoreInfo } from './StoreSwitcher';

export type SidebarProps = {
  groups?: NavGroupConfig[];
  store?: StoreInfo;
  stackHelp?: boolean;
};

/** Sidebar do painel: logo, navegação (de `APP_NAV`), loja e ajuda. */
export function Sidebar({ groups = APP_NAV, store = DEFAULT_STORE, stackHelp = false }: SidebarProps) {
  return (
    <aside className="sidebar">
      <NavLink to="/" aria-label="Lisboon">
        <Logo id="lg-side" />
      </NavLink>
      <nav className="nav" aria-label="Principal">
        {groups.map((g, i) => <NavGroup key={g.label ?? i} {...g} />)}
      </nav>
      <div className="side-bottom">
        <StoreSwitcher {...store} />
        <HelpBox stacked={stackHelp} />
      </div>
    </aside>
  );
}
